exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".sw-ts-menu .v-list-item{min-height:40px}", "", {"version":3,"sources":["/home/ponce-dev-production/report/src/components/FieldSurveys/SurveyWorkTechnicianSelect.vue"],"names":[],"mappings":"AACA,yBACE,eAAiB,CAClB","file":"SurveyWorkTechnicianSelect.vue","sourcesContent":["/* Dropdown menu width follows autocomplete */\n.sw-ts-menu .v-list-item {\n  min-height: 40px;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-273791ea","scoped":false,"hasInlineConfig":false}!./~/stylus-loader?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/FieldSurveys/SurveyWorkTechnicianSelect.vue
// module id = 1512
// module chunks = 0